import React from "react";
import { Fade, IconButton, Modal } from "@mui/material";
import { CloseIcon } from "@/components/icons";
import { CoverVideo } from "@/components/CoverVideo";
import { keyboardTrigger } from "@/helpers/utils";
import type { ShopifyMedia } from "@/store";

interface VideoModalProps {
  open: boolean;
  onClose: () => void;
  videoItem: ShopifyMedia;
  productTitle: string;
  autoPlay?: boolean;
}

export const VideoModal = ({
  open,
  onClose,
  videoItem,
  productTitle,
  autoPlay = false,
}: VideoModalProps) => {
  return (
    <Modal
      className="overflow-auto"
      role="dialog"
      aria-label="video modal popup"
      aria-modal={true}
      open={open}
      onClose={onClose}
    >
      <Fade in={open}>
        <div className="absolute left-1/2 top-1/2 max-h-full w-[96%] max-w-4xl -translate-x-1/2 -translate-y-1/2 transform rounded-md bg-white p-4 shadow-xl lg:w-full lg:p-5">
          <div className="flex items-start justify-between pb-4">
            <h3 className="text-md lg:text-inherit">
              {productTitle.split(",")[0]}
            </h3>
            <IconButton
              size="small"
              aria-label="close modal"
              color="inherit"
              onClick={onClose}
              onKeyDown={keyboardTrigger(onClose)}
            >
              <CloseIcon
                fontSize="small"
                className="transition hover:opacity-50"
                tabIndex={0}
              />
            </IconButton>
          </div>
          <CoverVideo
            alt={videoItem.alt || `${productTitle} highlight video`}
            url={videoItem.url}
            sources={videoItem.mediaType === "video" ? videoItem.sources : []}
            autoPlay={autoPlay}
          />
        </div>
      </Fade>
    </Modal>
  );
};
